'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var colors = {
  brandPrimary: '#8A2231',
  brandSecondary: '#C2002E',
  brandTertiary: '#510013',
  brandPrimaryText: '#FFFFFF',
  brandSecondaryText: '#333333',
  brandPrimaryLink: '#FFFFFF',
  brandSecondaryLink: '#C2002E',
  brandPrimaryLinkHover: '#EVEVEV',
  brandSecondaryLinkHover: '#510013',
  transparent: 'transparent'
};
var fonts = {
  primary: '"Helvetica"',
  secondary: 'sans-serif'
};
var mediaQueries = {
  xs: '480px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
  xl: '1400px'
};
var rhythm = {
  padding: 12,
  margin: 12,
  lineHeight: 1.428
};
exports.colors = colors;
exports.fonts = fonts;
exports.mediaQueries = mediaQueries;
exports.rhythm = rhythm;